<template>
  <div>
    <div
      v-for="(btn, i) in buttons.buttons"
      :key="i"
      class="message-container mt-2 g-3 d-flex flex-column"
      :style="
        i < buttons.buttons.length - 1
          ? 'border-bottom: 1px solid #E0E0E0;'
          : ''
      "
    >
      <v-btn
        block
        depressed
        class="text-none d-flex justify-start align-center my-0"
      >
        <v-icon v-if="getIcon(btn.type)" class="mr-3" color="#00a884">
          {{ getIcon(btn.type) }}
        </v-icon>
        <span class="font-weight-medium" style="color: #00a884">{{
          btn.text
        }}</span>
      </v-btn>

      <p v-if="!isValidLabel(btn)" class="yellow--text text--darken-3 mt-1">
        <v-icon small class="" color="#F9A825">mdi-alert-circle</v-icon>
        <span>
          Possível inconsistência no texto do botão ("{{ btn.text }}").
        </span>
      </p>

      <p v-if="!isValidUrl(btn)" class="yellow--text text--darken-3 mt-1">
        <v-icon small class="" color="#F9A825">mdi-alert-circle</v-icon>
        <span> Possível inconsistência na URL do botão. </span>
      </p>

      <p
        v-if="btn.url"
        class="mt-1"
        :class="!isValidUrl(btn) ? 'yellow--text text--darken-3' : ''"
      >
        <span>Url:</span>
        {{ btn.url }}
      </p>

      <p v-if="btn.type" class="mt-1 mb-2">
        <span>Tipo do botão:</span>
        {{ getButtonType(btn.type) }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ApproveDialog",
  props: {
    buttons: { type: Object, required: true, default: () => ({ buttons: [] }) },
  },
  computed: {
    ...mapGetters("initiativeManager", ["validUrls", "validLabels"]),
  },
  methods: {
    isValidButton(btn) {
      return this.isValidUrl(btn) && this.isValidLabel(btn);
    },
    isValidUrl(btn) {
      return btn.type !== "URL" || this.validUrls.includes(btn.url);
    },
    isValidLabel(btn) {
      return (
        btn.type !== "URL" ||
        (btn.url &&
          this.validLabels[btn.url] &&
          this.validLabels[btn.url].includes(btn.text))
      );
    },
    getIcon(type) {
      if (type === "FLOW") return "mdi-share-variant";
      if (type === "QUICK_REPLY") return "mdi-reply";
      if (type === "URL") return "mdi-open-in-new";
      return "";
    },

    getButtonType(type) {
      if (type === "FLOW") return "WhatsApp Flows";
      if (type === "QUICK_REPLY") return "Resposta rápida";
      if (type === "URL") return "Link";
      return type;
    },

    getLinkType(type) {
      if (type === "link") return "Negociação";
      if (type === "link_creditor") return "Credor";
      if (type === "link_unsubscribe") return "Descadastrar";
      if (type === "link_redirect") return "Link de redirecionamento";
      return type;
    },
  },
};
</script>

<style lang="scss" scoped>
.message-container {
  display: flex;
  flex-direction: column;
  max-width: 85%;
}
</style>
